"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INetworkAnalysisDependencyModuleModeResolutionSchema = exports.INetworkAnalysisDependencyPortCharacteristicResolutionSchema = exports.NetworkAnalysisDependencyPortCharacteristicResolutionTypeSchema = exports.NetworkAnalysisDependencyPortCharacteristicResolutionType = exports.INetworkAnalysisDependencySchema = exports.INetworkAnalysisDependencyPortCharacteristicSchema = exports.INetworkAnalysisDependencyUnconstrainedModeSchema = exports.INetworkAnalysisDependencyModuleModeSchema = exports.NetworkAnalysisDependencyTypeSchema = exports.NetworkAnalysisDependencyType = void 0;
const zod_1 = require("zod");
const BoundaryCharacteristic_1 = require("../../BoundaryCharacteristic");
const CharacteristicValue_1 = require("../../CircuitStates/CharacteristicValue");
var NetworkAnalysisDependencyType;
(function (NetworkAnalysisDependencyType) {
    NetworkAnalysisDependencyType["ModuleMode"] = "ModuleMode";
    NetworkAnalysisDependencyType["PortCharacteristic"] = "PortCharacteristic";
    NetworkAnalysisDependencyType["UnconstrainedMode"] = "UnconstrainedMode";
})(NetworkAnalysisDependencyType || (exports.NetworkAnalysisDependencyType = NetworkAnalysisDependencyType = {}));
exports.NetworkAnalysisDependencyTypeSchema = zod_1.default.nativeEnum(NetworkAnalysisDependencyType);
exports.INetworkAnalysisDependencyModuleModeSchema = zod_1.default.object({
    type: zod_1.default.literal(NetworkAnalysisDependencyType.ModuleMode),
    modeGlobalId: zod_1.default.string(),
    moduleName: zod_1.default.string(),
});
exports.INetworkAnalysisDependencyUnconstrainedModeSchema = zod_1.default.object({
    type: zod_1.default.literal(NetworkAnalysisDependencyType.UnconstrainedMode),
    modeGlobalId: zod_1.default.string(),
    moduleName: zod_1.default.string(),
});
exports.INetworkAnalysisDependencyPortCharacteristicSchema = zod_1.default.object({
    type: zod_1.default.literal(NetworkAnalysisDependencyType.PortCharacteristic),
    portId: zod_1.default.string(),
    netName: zod_1.default.string(),
    characteristic: zod_1.default.lazy(() => BoundaryCharacteristic_1.BoundaryCharacteristicSchema),
});
exports.INetworkAnalysisDependencySchema = zod_1.default.discriminatedUnion('type', [
    exports.INetworkAnalysisDependencyModuleModeSchema,
    exports.INetworkAnalysisDependencyUnconstrainedModeSchema,
    exports.INetworkAnalysisDependencyPortCharacteristicSchema,
]);
var NetworkAnalysisDependencyPortCharacteristicResolutionType;
(function (NetworkAnalysisDependencyPortCharacteristicResolutionType) {
    NetworkAnalysisDependencyPortCharacteristicResolutionType["BoundaryAnalysis"] = "BoundaryAnalysis";
    NetworkAnalysisDependencyPortCharacteristicResolutionType["SpiceSimulation"] = "SpiceSimulation";
    NetworkAnalysisDependencyPortCharacteristicResolutionType["Specified"] = "Specified";
})(NetworkAnalysisDependencyPortCharacteristicResolutionType || (exports.NetworkAnalysisDependencyPortCharacteristicResolutionType = NetworkAnalysisDependencyPortCharacteristicResolutionType = {}));
exports.NetworkAnalysisDependencyPortCharacteristicResolutionTypeSchema = zod_1.default.nativeEnum(NetworkAnalysisDependencyPortCharacteristicResolutionType);
exports.INetworkAnalysisDependencyPortCharacteristicResolutionSchema = zod_1.default.object({
    dependencyType: exports.NetworkAnalysisDependencyTypeSchema.refine((d) => d === NetworkAnalysisDependencyType.PortCharacteristic),
    portId: zod_1.default.string(),
    resolutionType: exports.NetworkAnalysisDependencyPortCharacteristicResolutionTypeSchema,
    result: CharacteristicValue_1.CharacteristicValueSchema,
});
exports.INetworkAnalysisDependencyModuleModeResolutionSchema = zod_1.default.object({
    dependencyType: exports.NetworkAnalysisDependencyTypeSchema.refine((d) => d === NetworkAnalysisDependencyType.ModuleMode),
    modeGlobalId: zod_1.default.string(),
    modeState: zod_1.default.boolean(),
});
//# sourceMappingURL=INetworkAnalysisDependency.js.map